// extracted by mini-css-extract-plugin
export var footer = "_ob-5";
export var fulfillmentInput = "_ob-0";
export var shipDateInput = "_ob-1";
export var shipmentModal = "_ob-2";
export var shipmentModalContent = "_ob-3";
export var tableContainer = "_ob-4";